export default [
  {
    tag: ["termo", "adesao", "migracao", "adesão"],
    result: {
      title: "Termo de adesão",
      url: "/meus-dados",
      key: "meus-dados",
      target: "_blank",
    },
  },
  {
    tag: [
      "boleto",
      "digital",
      "fatura",
      "conta",
      "cobranca",
      "correio",
      "correspondencia",
      "email",
      "editar",
      "dia",
    ],
    result: {
      title: "Preferência de cobrança",
      url: "/preferencia-cobranca",
      key: "boleto-digital",
      target: "_self",
    },
  },
  {
    tag: [
      "boleto",
      "fatura",
      "conta",
      "pagamento",
      "consta",
      "nada",
      "historico",
      "vencimento",
      "pago",
      "vencido",
      "vencer",
      "via",
      "2",
      "segunda",
      "valor",
      "debito",
      "janeiro",
      "fevereiro",
      "marco",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro",
    ],
    result: {
      title: "Boletos",
      url: "/consulta-debitos",
      key: "boletos",
      target: "_self",
    },
  },
  {
    tag: [
      "religue",
      "liga",
      "desliga",
      "gas",
      "desligue",
      "fornecimento",
      "desligamento",
      "bloqueio",
      "bloquear",
      "servico",
      "ligacao",
      "suspensao",
    ],
    result: {
      title: "Ligar e desligar gás",
      url: "/religue",
      key: "religue",
      target: "_self",
    },
  },
  // {
  //   tag: ["unidade", "minha"],
  //   result: {
  //     title: "Minha unidade",
  //     url: "/minha-unidade",
  //     key: "minha-unidade",
  //     target: "_self",
  //   },
  // },
  {
    tag: [
      "debito",
      "automatico",
      "fatura",
      "banco",
      "conta",
      "pagamento",
      "endereco",
    ],
    result: {
      title: "Débito automático",
      url: "/debito-automatico",
      key: "debito-automatico",
      target: "_self",
    },
  },
  {
    tag: [
      "conta",
      "gas",
      "consumo",
      "leitura",
      "volume",
      "contestacao",
      "analise",
      "anterior",
      "duvida",
      "medidor",
      "historico",
      "entenda",
    ],
    result: {
      title: "Minha conta de gás",
      url: "/consumo",
      key: "minha-conta",
      target: "_self",
    },
  },
  {
    tag: [
      "dados",
      "usuario",
      "alteracao",
      "nome",
      "social",
      "data",
      "nascimento",
      "email",
      "celular",
      "telefone",
      "contato",
    ],
    result: {
      title: "Meu perfil",
      url: "/meus-dados-novo",
      key: "meus-dados-novo",
      target: "_self",
    },
  },
  {
    tag: ["unidade", "adicionar", "nova"],
    result: {
      title: "Adicionar unidade",
      url: "/adicionar-unidade",
      key: "adicionar-unidade",
      target: "_self",
    },
  },
  {
    tag: [
      "fale",
      "conosco",
      "faq",
      "duvida",
      "chat",
      "boleto",
      "gas",
      "fatura",
      "nota",
      "fiscal",
      "fornecimento",
      "desligamento",
      "liga",
      "desliga",
      "desligue",
      "ligacao",
      "bloqueio",
      "pagamento",
      "duplicidade",
      "servico",
      "consumo",
      "volume",
      "valor",
      "cobranca",
      "nada",
      "consta",
      "compensacao",
      "pago",
      "vencido",
      "vencer",
      "juro",
      "multa",
      "ajuda",
      "ully",
      "adicionar",
      "unidade",
      "login",
      "saindo",
      "suspenso",
      "troca",
      "titularidade",
      "inadimplencia",
      "religue",
      "valvula",
      "entenda",
      "medicao",
      "individual",
      "parcelamento",
      "endereco",
    ],
    result: {
      title: "Fale conosco",
      url: "/fale-conosco",
      key: "fale-conosco",
      target: "_self",
    },
  },
];
